import React, { useCallback } from 'react';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import { PrimaryButton } from 'src/shared/design-system/Buttons';
import styled from 'styled-components';
import { Font, Spacing } from 'web-common/src/shared/styles';

const MaxWidthContainer = styled(DishFirstExploreWidthLimit)`
  margin-top: ${Spacing.QUADRUPLE};
  margin-bottom: ${Spacing.SINGLE};
  padding: ${Spacing.NONE} ${Spacing.SINGLE};

  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 35vh;
`;

const Copy = styled.h4`
  font-size: ${Font.Size.L};
  margin-bottom: ${Spacing.DOUBLE};
`;

interface IProps {
  className?: string;
  clearQueryParams: () => void;
}

export const NoResults: React.FC<IProps> = ({ className, clearQueryParams }) => {
  const clearFilters = useCallback(() => {
    clearQueryParams();
  }, [clearQueryParams]);

  return (
    <MaxWidthContainer className={className}>
      <Copy>Sorry, no shefs are cooking under your selected filters.</Copy>
      <PrimaryButton onClick={clearFilters}>Clear Filters</PrimaryButton>
    </MaxWidthContainer>
  );
};
